import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
const Receptionist = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate("/receptionist/patient");
  }, [navigate]);
  return <></>;
};

export default Receptionist;
